import { Button, Dropdown } from '@digdir/designsystemet-react';
import { ChevronDownIcon } from '@navikt/aksel-icons';
import { Link, useParams } from 'react-router-dom';
import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { queryClient, queryKeys } from '../../../../utils/react-query';
import { useArchiveAndCloneRegistration } from '../../../../components/enovaApplicationList/components/useArchiveAndCloneRegistration';
import { SimpleEnergyPlan } from '../../../../types/building';

import { MenuDropdownButton } from './styledComponents';
import { DeleteButton } from './deleteButton';

export const TilstandMenu = ({ energiplan }: { energiplan: SimpleEnergyPlan }) => {
  const { buildingId } = useParams();

  const url = energiplan.attestUri;
  const isPublished = !!energiplan.publisertDato;
  const { archiveRegistration, isLoading: isArchiving } = useArchiveAndCloneRegistration();
  const dropdownId = useId();
  const { t } = useTranslation('', { keyPrefix: 'screens.energiplan.components.tilstandMenu' });

  const onArchiveRegistration = () => {
    archiveRegistration(
      { registrationId: energiplan.registreringId, energiplanId: energiplan.energiplanId },
      {
        onSuccess: () => queryClient.invalidateQueries([queryKeys.energyAnalysisList, buildingId])
      }
    );
  };

  return (
    <>
      <Button variant="secondary" popovertarget={dropdownId} disabled={isArchiving}>
        {t('optionsButton')}
        <ChevronDownIcon aria-hidden />
      </Button>
      <Dropdown id={dropdownId}>
        <Dropdown.List>
          {!!url && (
            <Dropdown.Item>
              <MenuDropdownButton asChild>
                <a href={url} target="_blank" rel="noopener noreferrer" download>
                  {t('downloadButton')}
                </a>
              </MenuDropdownButton>
            </Dropdown.Item>
          )}
          {isPublished && (
            <Dropdown.Item>
              <MenuDropdownButton loading={isArchiving} onClick={onArchiveRegistration}>
                {t('editButton')}
              </MenuDropdownButton>
            </Dropdown.Item>
          )}
          {!isPublished && (
            <>
              <Dropdown.Item>
                <MenuDropdownButton asChild>
                  <Link to={`/registrer-energimerke/${energiplan.registreringId}/oppsummering`}>
                    {t('continueButton')}
                  </Link>
                </MenuDropdownButton>
              </Dropdown.Item>
              <Dropdown.Item>
                <DeleteButton registreringId={energiplan.registreringId} buildingId={buildingId} />
              </Dropdown.Item>
            </>
          )}
        </Dropdown.List>
      </Dropdown>
    </>
  );
};
